import { Link } from "react-router-dom";
import { COMPANY, BRANDS } from "../data";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative"
      style={{ background: "var(--forest)", color: "var(--cream)" }}
    >
      <div className="container-cu py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/assets/logo_casahaya.png"
                alt="Casa Haya International"
                className="w-12 h-12 rounded-md object-cover"
                style={{ border: "1px solid rgba(201,168,76,0.4)" }}
              />
              <span className="font-serif text-xl">Casa Haya International</span>
            </div>
            <p className="text-sm leading-relaxed max-w-md opacity-80">
              Luxury short stays in Northern Spain, and the operational home of
              three AI-native brands. Built with warmth, intention and purpose.
            </p>
            <div className="mt-8 flex items-center gap-3">
              {[
                { href: "https://instagram.com", icon: "fa-instagram", label: "Instagram" },
                { href: "https://youtube.com", icon: "fa-youtube", label: "YouTube" },
                { href: "https://facebook.com", icon: "fa-facebook-f", label: "Facebook" },
              ].map((s) => (
                <a
                  key={s.label}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label={s.label}
                  className="w-10 h-10 rounded-full inline-flex items-center justify-center transition-all"
                  style={{
                    border: "1px solid rgba(250,247,242,0.25)",
                    color: "var(--cream)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "var(--gold)";
                    e.currentTarget.style.color = "var(--forest)";
                    e.currentTarget.style.borderColor = "var(--gold)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "var(--cream)";
                    e.currentTarget.style.borderColor = "rgba(250,247,242,0.25)";
                  }}
                >
                  <i className={`fa-brands ${s.icon}`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow eyebrow-light mb-5">Explore</p>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-our-brands" to="/our-brands" className="link-underline">Our Brands</Link></li>
              <li><Link data-testid="footer-the-apartment" to="/the-apartment" className="link-underline">The Apartment</Link></li>
              <li><Link data-testid="footer-things-to-do" to="/things-to-do-nearby" className="link-underline">Things to Do Nearby</Link></li>
              <li><Link data-testid="footer-about" to="/about" className="link-underline">About</Link></li>
              <li><Link data-testid="footer-contact" to="/contact" className="link-underline">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="eyebrow eyebrow-light mb-5">Brands</p>
            <ul className="space-y-3 text-sm">
              {BRANDS.map((b) => (
                <li key={b.id}>
                  <a
                    data-testid={`footer-brand-${b.id}`}
                    href={b.url}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="link-underline"
                  >
                    {b.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="eyebrow eyebrow-light mb-5">Contact</p>
            <ul className="space-y-3 text-sm opacity-90">
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="link-underline"
                  data-testid="footer-email"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li className="leading-relaxed">
                {COMPANY.address}
              </li>
              <li className="opacity-70">KvK: {COMPANY.kvk}</li>
              <li className="opacity-70">BTW: {COMPANY.btw}</li>
            </ul>
          </div>
        </div>

        <div
          className="mt-16 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs opacity-70"
          style={{ borderTop: "1px solid rgba(250,247,242,0.18)" }}
        >
          <p>
            © 2026 Casa Haya International BV · Casa De La Haya Real Estate Holding BV · All rights reserved.
          </p>
          <p className="italic font-serif text-sm" style={{ color: "var(--gold-soft)" }}>
            My different is my normal.
          </p>
        </div>
      </div>
    </footer>
  );
}
